export * from "-!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/framevuerk-builder/node_modules/pug-html-loader/lib/index.js!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/index.js??vue-loader-options!./fvList.vue?vue&type=template&id=a9093e24&lang=pug&"


//////////////////
// WEBPACK FOOTER
// ./src/components/fvList.vue?vue&type=template&id=a9093e24&lang=pug&
// module id = 116
// module chunks = 0 1